module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Lisa Hagemann-11200b82f42270f918be921fab60cdf4.jpg";